import { render, staticRenderFns } from "./clipper-fixed.vue?vue&type=template&id=18a93688&scoped=true&"
import script from "./clipper-fixed.vue?vue&type=script&lang=js&"
export * from "./clipper-fixed.vue?vue&type=script&lang=js&"
import style0 from "./clipper-fixed.vue?vue&type=style&index=0&id=18a93688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a93688",
  null
  
)

export default component.exports